import { CONSULTING_WINDOW } from '../../constants.js';

export function consultingApp(){
  return {
    type : CONSULTING_WINDOW.CONSULTING,
  };
}

export function noConsultingApp(){
  return {
    type : CONSULTING_WINDOW.NO_CONSULTING,
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/A_reducer_consulting.js